// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "billing/v1/billingadministration.proto" (package "billing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BillingAdministrationService } from "./billingadministration";
import type { GetOrganizationsByCurrentMonthUsageResponse } from "./billingadministration";
import type { GetOrganizationsByCurrentMonthUsageRequest } from "./billingadministration";
import type { GetBillableRegistryItemDisbursementsResponse } from "./billingadministration";
import type { GetBillableRegistryItemDisbursementsRequest } from "./billingadministration";
import type { PermanentlyDeleteOrganizationResponse } from "./billingadministration";
import type { PermanentlyDeleteOrganizationRequest } from "./billingadministration";
import type { GetInvoicesRequiringManualAttentionResponse } from "./billingadministration";
import type { GetInvoicesRequiringManualAttentionRequest } from "./billingadministration";
import type { GetOrganizationsWithOverduePaymentsResponse } from "./billingadministration";
import type { GetOrganizationsWithOverduePaymentsRequest } from "./billingadministration";
import type { SuspendOrganizationResponse } from "./billingadministration";
import type { SuspendOrganizationRequest } from "./billingadministration";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SetInvoiceStatusResponse } from "./billingadministration";
import type { SetInvoiceStatusRequest } from "./billingadministration";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service billing.v1.BillingAdministrationService
 */
export interface IBillingAdministrationServiceClient {
    /**
     * Set the status of an invoice
     *
     * @generated from protobuf rpc: SetInvoiceStatus(billing.v1.SetInvoiceStatusRequest) returns (billing.v1.SetInvoiceStatusResponse);
     */
    setInvoiceStatus(input: SetInvoiceStatusRequest, options?: RpcOptions): UnaryCall<SetInvoiceStatusRequest, SetInvoiceStatusResponse>;
    /**
     * @generated from protobuf rpc: SuspendOrganization(billing.v1.SuspendOrganizationRequest) returns (billing.v1.SuspendOrganizationResponse);
     */
    suspendOrganization(input: SuspendOrganizationRequest, options?: RpcOptions): UnaryCall<SuspendOrganizationRequest, SuspendOrganizationResponse>;
    /**
     * @generated from protobuf rpc: GetOrganizationsWithOverduePayments(billing.v1.GetOrganizationsWithOverduePaymentsRequest) returns (billing.v1.GetOrganizationsWithOverduePaymentsResponse);
     */
    getOrganizationsWithOverduePayments(input: GetOrganizationsWithOverduePaymentsRequest, options?: RpcOptions): UnaryCall<GetOrganizationsWithOverduePaymentsRequest, GetOrganizationsWithOverduePaymentsResponse>;
    /**
     * @generated from protobuf rpc: GetInvoicesRequiringManualAttention(billing.v1.GetInvoicesRequiringManualAttentionRequest) returns (billing.v1.GetInvoicesRequiringManualAttentionResponse);
     */
    getInvoicesRequiringManualAttention(input: GetInvoicesRequiringManualAttentionRequest, options?: RpcOptions): UnaryCall<GetInvoicesRequiringManualAttentionRequest, GetInvoicesRequiringManualAttentionResponse>;
    /**
     * @generated from protobuf rpc: PermanentlyDeleteOrganization(billing.v1.PermanentlyDeleteOrganizationRequest) returns (billing.v1.PermanentlyDeleteOrganizationResponse);
     */
    permanentlyDeleteOrganization(input: PermanentlyDeleteOrganizationRequest, options?: RpcOptions): UnaryCall<PermanentlyDeleteOrganizationRequest, PermanentlyDeleteOrganizationResponse>;
    /**
     * @generated from protobuf rpc: GetBillableRegistryItemDisbursements(billing.v1.GetBillableRegistryItemDisbursementsRequest) returns (billing.v1.GetBillableRegistryItemDisbursementsResponse);
     */
    getBillableRegistryItemDisbursements(input: GetBillableRegistryItemDisbursementsRequest, options?: RpcOptions): UnaryCall<GetBillableRegistryItemDisbursementsRequest, GetBillableRegistryItemDisbursementsResponse>;
    /**
     * @generated from protobuf rpc: GetOrganizationsByCurrentMonthUsage(billing.v1.GetOrganizationsByCurrentMonthUsageRequest) returns (billing.v1.GetOrganizationsByCurrentMonthUsageResponse);
     */
    getOrganizationsByCurrentMonthUsage(input: GetOrganizationsByCurrentMonthUsageRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByCurrentMonthUsageRequest, GetOrganizationsByCurrentMonthUsageResponse>;
}
/**
 * @generated from protobuf service billing.v1.BillingAdministrationService
 */
export class BillingAdministrationServiceClient implements IBillingAdministrationServiceClient, ServiceInfo {
    typeName = BillingAdministrationService.typeName;
    methods = BillingAdministrationService.methods;
    options = BillingAdministrationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Set the status of an invoice
     *
     * @generated from protobuf rpc: SetInvoiceStatus(billing.v1.SetInvoiceStatusRequest) returns (billing.v1.SetInvoiceStatusResponse);
     */
    setInvoiceStatus(input: SetInvoiceStatusRequest, options?: RpcOptions): UnaryCall<SetInvoiceStatusRequest, SetInvoiceStatusResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetInvoiceStatusRequest, SetInvoiceStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SuspendOrganization(billing.v1.SuspendOrganizationRequest) returns (billing.v1.SuspendOrganizationResponse);
     */
    suspendOrganization(input: SuspendOrganizationRequest, options?: RpcOptions): UnaryCall<SuspendOrganizationRequest, SuspendOrganizationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SuspendOrganizationRequest, SuspendOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetOrganizationsWithOverduePayments(billing.v1.GetOrganizationsWithOverduePaymentsRequest) returns (billing.v1.GetOrganizationsWithOverduePaymentsResponse);
     */
    getOrganizationsWithOverduePayments(input: GetOrganizationsWithOverduePaymentsRequest, options?: RpcOptions): UnaryCall<GetOrganizationsWithOverduePaymentsRequest, GetOrganizationsWithOverduePaymentsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationsWithOverduePaymentsRequest, GetOrganizationsWithOverduePaymentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoicesRequiringManualAttention(billing.v1.GetInvoicesRequiringManualAttentionRequest) returns (billing.v1.GetInvoicesRequiringManualAttentionResponse);
     */
    getInvoicesRequiringManualAttention(input: GetInvoicesRequiringManualAttentionRequest, options?: RpcOptions): UnaryCall<GetInvoicesRequiringManualAttentionRequest, GetInvoicesRequiringManualAttentionResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInvoicesRequiringManualAttentionRequest, GetInvoicesRequiringManualAttentionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PermanentlyDeleteOrganization(billing.v1.PermanentlyDeleteOrganizationRequest) returns (billing.v1.PermanentlyDeleteOrganizationResponse);
     */
    permanentlyDeleteOrganization(input: PermanentlyDeleteOrganizationRequest, options?: RpcOptions): UnaryCall<PermanentlyDeleteOrganizationRequest, PermanentlyDeleteOrganizationResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<PermanentlyDeleteOrganizationRequest, PermanentlyDeleteOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBillableRegistryItemDisbursements(billing.v1.GetBillableRegistryItemDisbursementsRequest) returns (billing.v1.GetBillableRegistryItemDisbursementsResponse);
     */
    getBillableRegistryItemDisbursements(input: GetBillableRegistryItemDisbursementsRequest, options?: RpcOptions): UnaryCall<GetBillableRegistryItemDisbursementsRequest, GetBillableRegistryItemDisbursementsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBillableRegistryItemDisbursementsRequest, GetBillableRegistryItemDisbursementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetOrganizationsByCurrentMonthUsage(billing.v1.GetOrganizationsByCurrentMonthUsageRequest) returns (billing.v1.GetOrganizationsByCurrentMonthUsageResponse);
     */
    getOrganizationsByCurrentMonthUsage(input: GetOrganizationsByCurrentMonthUsageRequest, options?: RpcOptions): UnaryCall<GetOrganizationsByCurrentMonthUsageRequest, GetOrganizationsByCurrentMonthUsageResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationsByCurrentMonthUsageRequest, GetOrganizationsByCurrentMonthUsageResponse>("unary", this._transport, method, opt, input);
    }
}
